<template>
    <interview-action-enter v-bind="{ code: value?.code }" v-slot="{ enter, loading, errorMessages }">
        <v-tooltip bottom :disabled="!errorMessages">
            <template #activator="{ attrs, on }">
                <slot
                    v-bind="{
                        attrs: {
                            ...attrs,
                            color: errorMessages ? 'red' : 'primary',
                            loading,
                        },
                        on: {
                            ...on,
                            click: enter,
                        },
                    }"
                />
            </template>
            {{ errorMessages }}
        </v-tooltip>
    </interview-action-enter>
</template>

<script>
import { initInterview } from "@/assets/variables";

import InterviewActionEnter from "@/components/dashboard/common/interview/action/interview-action-enter.vue";

export default {
    components: {
        InterviewActionEnter,
    },
    props: {
        value: { type: Object, default: initInterview }, // interview
    },
};
</script>

<style>
</style>